import SiteLayout from "@/components/feature/SiteLayout";
import PageHero from "@/components/base/PageHero";
import SectionDivider from "@/components/base/SectionDivider";
import useDocumentMeta from "@/hooks/useDocumentMeta";
import ServicesSection from "@/pages/home/components/ServicesSection";
import ComparisonSection from "@/pages/home/components/ComparisonSection";
import CtaSection from "@/pages/home/components/CtaSection";

export default function Services() {
  useDocumentMeta({
    title: "Hizmetler | Panoramik ve 3D Dental Tomografi — d.mar",
    description:
      "Panoramik röntgen, Panoral 5, çocuk panoramik, bite-wing, sefalometrik, el-bilek, TME ve 3D dental tomografi (CBCT) hizmetleri; aynı gün dijital rapor.",
    path: "/hizmetler",
  });

  return (
    <SiteLayout>
      <PageHero
        crumb="Hizmetler"
        eyebrow="Hizmetlerimiz"
        title="Diş hekiminizin istediği tüm dental görüntülemeler"
        description="Panoramik röntgenden 3D dental tomografiye (CBCT) kadar dokuz farklı görüntüleme yöntemini tek çatı altında; düşük doz, dijital ve aynı gün raporlu olarak sunuyoruz."
      />
      <ServicesSection />
      <SectionDivider />
      <ComparisonSection />
      <CtaSection />
    </SiteLayout>
  );
}